import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { Candidacy, HttpResponse, UpdateCandidacyRequest } from "@/types";

export function useUpdateCandidacy() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      candidacyId,
      updateCandidacyRequest,
    }: {
      candidacyId: string;
      updateCandidacyRequest: UpdateCandidacyRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}`;
      const res = await httpClient.patch<
        Candidacy,
        HttpResponse<Candidacy>,
        UpdateCandidacyRequest
      >(path, updateCandidacyRequest);

      return res.data;
    },
  });

  return mutation;
}
